module.exports = __webpack_public_path__ + "img/0Q3A5610_FoamcoreMatted.3b1b780b.jpg";